import {
  AiOutlineFileImage,
  AiOutlineFilePdf,
  AiOutlineFileUnknown,
} from "react-icons/ai";

interface Props {
  size: number;
  mimeType: string | undefined | null;
}

const IpisFileIcon = (props: Props) => {
  const mimeType = props.mimeType;
  if (mimeType?.includes("image")) {
    return <AiOutlineFileImage size={props.size} />;
  }

  if (mimeType?.includes("pdf")) {
    return <AiOutlineFilePdf size={props.size} />;
  }

  return <AiOutlineFileUnknown size={props.size} />;
};

export default IpisFileIcon;
